// In-memory session cache with TTL support.
// Data lives only while the tab is open (no localStorage/sessionStorage).
// Each key stores a value + expiration timestamp.

interface CacheEntry<T> {
  value: T;
  expiresAt: number;
}

const store = new Map<string, CacheEntry<unknown>>();

const DEFAULT_TTL_MS = 5 * 60 * 1000; // 5 minutes

export function getCached<T>(key: string): T | null {
  const entry = store.get(key);
  if (!entry) return null;
  if (Date.now() > entry.expiresAt) {
    store.delete(key);
    return null;
  }
  return entry.value as T;
}

export function setCached<T>(key: string, value: T, ttlMs = DEFAULT_TTL_MS): void {
  store.set(key, { value, expiresAt: Date.now() + ttlMs });
}

export function invalidateCache(key: string): void {
  store.delete(key);
}

export function invalidateCacheByPrefix(prefix: string): void {
  for (const k of store.keys()) {
    if (k.startsWith(prefix)) store.delete(k);
  }
}

// Pre-defined cache keys
export const CACHE_KEYS = {
  USER_PROFILE: 'user:profile',
  COMPANY_DATA: 'company:data',
  COMPANY_CONFIG: 'company:config',
  MENSAJES_INICIO: 'mensajes:inicio',
  TN_STATUS: 'company:tn_status',
} as const;
